import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export default class NotFound extends React.Component {

	render(): ReactElement {
		return (
			<div>
				<h1>404: Not found</h1>
				<h3><Link to='/'>Return to home</Link></h3>
			</div>
		);
	}
}